export const centerFocusIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 6a4 4 0 1 0 0 8 4 4 0 1 0 0-8zm-7 7H1v4c0 1.1.9 2 2 2h4v-2H3v-4zM3 3h4V1H3c-1.1 0-2 .9-2 2v4h2V3zm14-2h-4v2h4v4h2V3c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/></svg>`,
  name: 'center-focus',
};
